import { StopAPI } from '../../../api/datamanager/StopAPI';

export class StopsDraftCommand {
    get(edition, providerId, computeLines, successCallback, errorCallback) {
        const apiResult = StopAPI.listDraft(edition.draftNetwork, providerId, computeLines);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("[Rascunho] Ocorreu um erro a ler as paragens");
            }
        });
    }

    getStopLines(edition, stopId, successCallback, errorCallback) {
        const apiResult = StopAPI.linesDraft(edition.draftNetwork, stopId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getLinesWithStops(edition, successCallback, errorCallback) {
        const apiResult = StopAPI.linesWithStopsDraft(edition.draftNetwork);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getStopMunicipality(edition, stopId, successCallback, errorCallback) {
        const apiResult = StopAPI.municipalityDraft(edition.draftNetwork, stopId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getWithoutMapPoint(edition, providerId, successCallback, errorCallback) {
        const apiResult = StopAPI.listDraftWithoutMapPoints(edition.draftNetwork, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("[Rascunho] Ocorreu um erro a ler as paragens");
            }
        });
    }

    count(draftNetworkEdition, providerId, successCallback, errorCallback) {
        const apiResult = StopAPI.countDraft(draftNetworkEdition, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, stop, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(undefined === stop.id || 0 === stop.id) {
            apiResult = StopAPI.createDraft(edition.draftNetwork, stop);
            successMessage = "[Rascunho] Paragem criada com sucesso";
        }
        else {
            apiResult = StopAPI.updateDraft(edition.draftNetwork, stop.id, stop);
            successMessage = "[Rascunho] Paragem editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveBulk(edition, stops, successCallback, errorCallback) {
        const apiResult = StopAPI.createStopsDraft(edition.draftNetwork, stops);
        const successMessage = "[Rascunho] Paragens criadas com sucesso";
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    editBulk(edition, stops, successCallback, errorCallback) {
        const apiResult = StopAPI.updateStops(edition.draftNetwork, stops);
        const successMessage = "[Rascunho] Paragens editadas com sucesso";
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, stopId, successCallback, errorCallback) {
        const apiResult = StopAPI.deleteDraft(edition.draftNetwork, stopId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Paragem eliminada com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    deleteBulk(edition, stops, successCallback, errorCallback) {
        const apiResult = StopAPI.deleteStopsDraft(edition.draftNetwork, stops);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Paragens eliminadas com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
